import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  props: {
    promp: {
      maxNum: {
        //输入框内容
        type: Number,
        default: 3
      },
      inputCent: {
        //输入框内容
        type: String,
        default: ''
      },
      name: {
        //输入提示的名称
        type: String,
        default: ''
      },
      placeholder: {
        //输入提示
        type: String,
        default: '请输入'
      },
      title: {
        type: String,
        default: '' //题头名字

      },
      propLeft: {
        //左边文字 (可传可不传)
        type: String,
        default: ''
      },
      propRight: {
        //右边文字 (可传可不传)
        type: String,
        default: ''
      }
    }
  },
  data: function data() {
    return {};
  },
  computed: {
    btnTextLeft: function btnTextLeft() {
      if (this.promp.propLeft) {
        return this.promp.propLeft;
      }

      return '取消';
    },
    btnTextRight: function btnTextRight() {
      if (this.promp.propRight) {
        return this.promp.propRight;
      }

      return '确定';
    }
  },
  methods: {
    /**
     * 取消按钮事件点击
     */
    cancel: function cancel() {
      this.$emit('cancel');
    },

    /**
     * 确认按钮事件点击
     */
    confirm: function confirm() {
      this.$emit('confirm', this.promp.inputCent);
    },

    /**
     * 关闭事件点击
     */
    closeFrame: function closeFrame() {
      this.$emit('closeFrame');
    }
  }
};